Wee.fn.make('hideFingerprintCta', {
	init: function() {
		var $button = $('ref:fingerprintButton'),
			hidden = '-is-hidden';

		$.get('hideFingerprintButton') ?
			$button.addClass(hidden) :
			$button.removeClass(hidden);
	},
	unload: function() {
		$.set('hideFingerprintButton', false);
		$('ref:fingerprintButton').removeClass('-is-hidden');
	}
});